import React from "react";
import { logo } from "../assets"; // Adjust the path to where your logo file is located

export const PixelPerfectLogo = () => {
  return <img src={logo} alt="PixelPerfect Logo" className="h-12 w-8" />;
};
